import {observer} from 'mobx-react-lite'
import React, {useState} from 'react'
import {Lang} from 'yougile-lang'
import {DataObjectId} from 'yougile-model'
import {Checkbox} from '@components/common/base/checkbox'
import {Select} from '@components/common/base/select'
import {SelectWithCheckboxes} from '@components/common/base/select-with-dropdown/select-with-checkboxes'
import {UsersTable} from '@components/common/base/users-table'
import {DropdownContent} from '@components/common/dropdown/dropdown-content'
import {useByTimeStore} from '@components/statistics/by-time/by-time-store'
import {TwFilter, TwFilters} from '@components/statistics/by-time/containers'
import AvatarIcon from '@components/statistics/stats-reports/filter-components/avatar.svg'

export const Filters = observer(() => {
  const [, store] = useByTimeStore()

  return (
    <TwFilters>
      <TwFilter>
        <div>{Lang.msg.report.designatedEmployees}</div>
        <UsersFilter />
      </TwFilter>
      {Boolean(store.tasksLocationOptions.length) && (
        <TwFilter>
          <div>{Lang.msg.report.location}</div>
          <div>
            <SelectWithCheckboxes
              variant="new"
              className="text-14 bg-primary max-w-[200px]"
              innerClassName="max-w-[200px] min-w-[200px]"
              options={store.tasksLocationOptions}
              value={store.tasksLocationFilterValue}
              onChange={store.onChangeTaskLocationFilter}
            />
          </div>
        </TwFilter>
      )}
      <TwFilter>
        <div>{Lang.msg.report.completeness}</div>
        <SelectWithCheckboxes
          className="bg-primary max-w-[200px]"
          variant="new"
          value={store.tasksCompletionValue}
          options={store.tasksCompletionOptions}
          onChange={store.onChangeTaskCompletionFilter}
        />
      </TwFilter>
      <TwFilter>
        <div>{Lang.msg.report.archival}</div>
        <SelectWithCheckboxes
          className="bg-primary max-w-[200px]"
          variant="new"
          value={store.tasksArchivedValue}
          options={store.tasksArchivedOptions}
          onChange={store.onChangeTaskArchivedFilter}
        />
      </TwFilter>
    </TwFilters>
  )
})

const UsersFilter = observer(() => {
  const [open, setOpen] = useState(false)
  const [state, store] = useByTimeStore()

  const toggleUsers = (users: DataObjectId[] | 'not-set') => {
    if (users === 'not-set') {
      store.toggleUsersFilterNotSet()
    } else {
      store.toggleUsersFilter(users)
    }
  }

  return (
    <div>
      <Select
        className="bg-primary"
        variant="new"
        open={open}
        onOpenChange={v => setOpen(v)}
        content={
          <DropdownContent
            className="w-[320px] h-[290px]"
            header={Lang.msg.coworkers}
          >
            <UsersTable
              className="h-full"
              users={store.currentBoardUsers}
              useCheckbox={true}
              selected={Array.from(state.tasksFilterValues?.users || [])}
              onToggled={toggleUsers}
              underHeadElement={
                <div
                  className="flex items-center h-32 px-16 cursor-pointer text-12"
                  onClick={() => toggleUsers('not-set')}
                >
                  <div className="w-24 px-4">
                    <div className="flex items-center">
                      <Checkbox
                        className="ml-4"
                        value={state.tasksFilterValues.notSetUsers}
                      />
                    </div>
                  </div>
                  <div className="mr-4 ml-16 w-16 h-16">
                    <AvatarIcon />
                  </div>
                  {Lang.msg.statsUserNotSet}
                </div>
              }
            />
          </DropdownContent>
        }
      >
        {store.usersFilterValue}
      </Select>
    </div>
  )
})
